import React, { useState, useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import logo from '../../assets/logo.jpg';
import './Navbar.css';

export default function Navbar({
  onOpenLogin,
  onOpenFacture, onOpenDevis, onOpenFinancial, onOpenAdmin,
  onOpenDocs, onOpenArchives, onOpenEtudiants, onOpenPersonnel,
}) {
  const { currentUser, logout, data, enterVisitorMode, exitVisitorMode, isVisitorMode, cartCount, setShowCart } = useApp();
  const isAdmin   = currentUser?.role === 'admin';
  const isManager = currentUser?.role === 'manager';
  const newCount  = (isAdmin || isManager)
    ? (data.transactions||[]).filter(t=>t.statut==='nouveau').length : 0;

  const [menuOpen,     setMenuOpen]     = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  function closeMenu() { setMenuOpen(false); }

  useEffect(() => {
    function handleClick(e) {
      if (!e.target.closest('.nav-dropdown')) setOpenDropdown(null);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <>
      <nav className="navbar">

        <a href="#accueil" className="nav-logo" onClick={closeMenu}>
          <img src={logo} alt="KOTOSTECHNOLOGY" className="nav-logo-img" />
          <div>
            <div className="nav-brand">KOTOSTECHNOLOGY</div>
            <div className="nav-tagline">Excellence · Innovation · Performance</div>
          </div>
        </a>

        <ul className="nav-links">
          <li><a href="#services">Services</a></li>
          <li><a href="#digitalisation">Digitalisation</a></li>
          <li><a href="#boutique">🛒 Boutique</a></li>
          <li><a href="#tarifs">Tarifs</a></li>
          <li><a href="#immobilier">Immobilier</a></li>
          <li><a href="#formations">Formations</a></li>
          <li><a href="#contact">Contact</a></li>
          <li><a href="#equipe">Équipe</a></li>
        </ul>

        <div className="nav-right">
          <button className="nav-cart-btn" onClick={() => setShowCart(true)} aria-label="Panier">
            🛒{cartCount > 0 && <span className="nav-cart-badge">{cartCount}</span>}
          </button>
          {currentUser && (
            <div className="nav-user">
              <strong>{currentUser.name}</strong>
              <span>{currentUser.role.toUpperCase()}</span>
            </div>
          )}
          {currentUser && (
            <>
              <button className="nav-btn nb-blue" onClick={onOpenFacture}>🧾 Facture</button>
              <button className="nav-btn nb-blue" onClick={onOpenDevis}>📋 Devis</button>
            </>
          )}
          {(isAdmin || isManager) && (
            <div className="nav-dropdown">
              <button
                className="nav-btn nb-arc"
                onClick={() => setOpenDropdown(openDropdown === 'gestion' ? null : 'gestion')}
              >
                🗄️ Gestion {openDropdown === 'gestion' ? '▴' : '▾'}
              </button>
              {openDropdown === 'gestion' && (
                <div className="nav-dropdown-menu">
                  <button onClick={() => { onOpenArchives(); setOpenDropdown(null); }}>
                    🗄️ Archives {newCount > 0 && <span className="mm-badge">{newCount}</span>}
                  </button>
                  <button onClick={() => { onOpenEtudiants(); setOpenDropdown(null); }}>🎓 Étudiants</button>
                  <button onClick={() => { onOpenPersonnel(); setOpenDropdown(null); }}>👥 Personnel</button>
                  <button onClick={() => { onOpenDocs(); setOpenDropdown(null); }}>📂 Docs</button>
                </div>
              )}
            </div>
          )}
          {isAdmin && (
            <div className="nav-dropdown">
              <button
                className="nav-btn nb-gold"
                onClick={() => setOpenDropdown(openDropdown === 'admin' ? null : 'admin')}
              >
                ⚙ Admin {openDropdown === 'admin' ? '▴' : '▾'}
              </button>
              {openDropdown === 'admin' && (
                <div className="nav-dropdown-menu">
                  <button onClick={() => { onOpenFinancial(); setOpenDropdown(null); }}>📊 Finances</button>
                  <button onClick={() => { onOpenAdmin(); setOpenDropdown(null); }}>⚙ Administration</button>
                  <button onClick={() => { enterVisitorMode(); setOpenDropdown(null); }}>👁 Vue Client</button>
                </div>
              )}
            </div>
          )}
          {currentUser
           ? <button className="nav-btn nb-red" onClick={logout} title="Se déconnecter">
  <span className="nav-btn-icon">⏻</span>
  <span className="nav-btn-txt">Quitter</span>
</button>
            : <button className="nav-btn nb-private" onClick={onOpenLogin}>🔐 Espace Privé</button>
          }
        </div>

        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menu"
        >
          <span/><span/><span/>
        </button>

      </nav>

      {menuOpen && (
        <div className="mobile-menu" onClick={closeMenu}>
          <div className="mobile-menu-inner" onClick={e => e.stopPropagation()}>
            <a href="#services"   className="mm-link" onClick={closeMenu}>Services</a>
            <a href="#boutique"   className="mm-link" onClick={closeMenu}>🛒 Boutique</a>
            <a href="#tarifs"     className="mm-link" onClick={closeMenu}>Tarifs</a>
            <a href="#immobilier" className="mm-link" onClick={closeMenu}>Immobilier</a>
            <a href="#formations" className="mm-link" onClick={closeMenu}>Formations</a>
            <a href="#contact"    className="mm-link" onClick={closeMenu}>Contact</a>
            <a href="#equipe"     className="mm-link" onClick={closeMenu}>Équipe</a>
            <button className="mm-btn mb-blue" onClick={() => { setShowCart(true); closeMenu(); }}>
              🛒 Mon panier {cartCount > 0 && <span className="mm-badge">{cartCount}</span>}
            </button>
            <div className="mm-sep" />
            {currentUser && (
              <div className="mm-user">
                <span>👤 {currentUser.name}</span>
                <span className="mm-role">{currentUser.role.toUpperCase()}</span>
              </div>
            )}
            {currentUser && (
              <>
                <button className="mm-btn mb-blue" onClick={() => { onOpenFacture(); closeMenu(); }}>🧾 Créer une Facture</button>
                <button className="mm-btn mb-blue" onClick={() => { onOpenDevis(); closeMenu(); }}>📋 Créer un Devis</button>
              </>
            )}
            {(isAdmin || isManager) && (
              <>
                <button className="mm-btn mb-arc" onClick={() => { onOpenArchives(); closeMenu(); }}>
                  🗄️ Archives {newCount > 0 && <span className="mm-badge">{newCount}</span>}
                </button>
                <button className="mm-btn mb-etud" onClick={() => { onOpenEtudiants(); closeMenu(); }}>🎓 Étudiants & Alumni</button>
                <button className="mm-btn mb-pers" onClick={() => { onOpenPersonnel(); closeMenu(); }}>👥 Personnel</button>
                <button className="mm-btn mb-docs" onClick={() => { onOpenDocs(); closeMenu(); }}>📂 Documents</button>
              </>
            )}
            {isAdmin && (
              <>
                <button className="mm-btn mb-gold"   onClick={() => { onOpenFinancial(); closeMenu(); }}>📊 Finances</button>
                <button className="mm-btn mb-gold"   onClick={() => { onOpenAdmin(); closeMenu(); }}>⚙ Administration</button>
                <button className="mm-btn mb-violet" onClick={() => { enterVisitorMode(); closeMenu(); }}>👁 Vue Client</button>
              </>
            )}
            {currentUser
              ? <button className="mm-btn mb-red"     onClick={() => { logout(); closeMenu(); }}>⏻ Se déconnecter</button>
              : <button className="mm-btn mb-private" onClick={() => { onOpenLogin(); closeMenu(); }}>🔐 Espace Privé</button>
            }
          </div>
        </div>
      )}

      {isVisitorMode && (
        <div className="visitor-banner">
          <div className="vb-left">
            <span className="vb-dot" />
            <span className="vb-label">MODE VISITEUR ACTIF</span>
            <span className="vb-desc">Vous voyez le site comme un client.</span>
          </div>
          <button className="vb-back" onClick={exitVisitorMode}>← Retourner en mode Admin</button>
        </div>
      )}
    </>
  );
}